import { render, staticRenderFns } from "./ConfirmDisableAwardModal.vue?vue&type=template&id=4a37d864&"
import script from "./ConfirmDisableAwardModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmDisableAwardModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports